import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import { classNames } from 'primereact/utils'

type Props = {
  title?: string
  className: string
  onClick: () => void
  materialIcon?: string
  faIcon?: IconDefinition
  label: string
  labelClassName?: string
}

const ActionButton = ({
  className,
  faIcon,
  materialIcon,
  onClick,
  title,
  label,
  labelClassName,
}: Props) => {
  const iconClassName = clsx('material-icons', 'text-[20px]')

  return (
    <div className={clsx(className, 'p-1 flex gap-1')} onClick={onClick} title={title}>
      {materialIcon && <span className={iconClassName}>{materialIcon}</span>}
      {faIcon && <FontAwesomeIcon icon={faIcon} className={iconClassName} />}
      <div className={classNames('inline-block leading-5', labelClassName)}>{label}</div>
    </div>
  )
}

export default ActionButton
